import React from 'react'
import {
  Show,
  TextField,
  SimpleShowLayout,
  Datagrid,
  ArrayField,
  ReferenceField,
  DateField,
  NumberField,
} from 'react-admin'

const EvaluationsShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout redirect="show">
      <ReferenceField label="Email" source="profileId" reference="accounts" target="id">
        <TextField source="email" />
      </ReferenceField>
      <DateField source="date" label="Date de l'évaluation" />
      <ArrayField source="results" label="Résultats">
        <Datagrid>
          <TextField source="type" label="Type" />
          <TextField source="question" label="Question" />
          <NumberField source="feedback" label="Réponse" />
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
)

export default EvaluationsShow
